const STORAGE_KEY = 'ivs-player-identity-v1';
export const PLAYER_AVATARS = Object.freeze([
  { id: 'fox', symbol: '🦊', label: 'Cáo' },
  { id: 'panda', symbol: '🐼', label: 'Gấu trúc' },
  { id: 'tiger', symbol: '🐯', label: 'Hổ' },
  { id: 'penguin', symbol: '🐧', label: 'Chim cánh cụt' },
  { id: 'owl', symbol: '🦉', label: 'Cú mèo' },
  { id: 'koala', symbol: '🐨', label: 'Koala' },
  { id: 'frog', symbol: '🐸', label: 'Ếch' },
  { id: 'lion', symbol: '🦁', label: 'Sư tử' }
]);

function safeParse(value) {
  try { return JSON.parse(value); } catch { return null; }
}

function normalizeStored(value) {
  if (!value || typeof value !== 'object') return null;
  if (typeof value.token !== 'string' || !value.token) return null;
  if (!value.profile || typeof value.profile.playerId !== 'string') return null;
  return {
    token: value.token,
    expiresAt: Number(value.expiresAt || 0),
    profile: value.profile
  };
}

export class PlayerIdentityClient {
  constructor({
    baseUrl,
    storage = globalThis.localStorage,
    fetchImpl = (...args) => fetch(...args)
  }) {
    this.baseUrl = String(baseUrl || '').replace(/\/$/, '');
    this.storage = storage;
    this.fetchImpl = fetchImpl;
    this.session = normalizeStored(safeParse(storage?.getItem(STORAGE_KEY)));
    this.pendingGuest = null;
  }

  get token() { return this.session?.token || ''; }
  get profile() { return this.session?.profile || null; }
  get playerId() { return this.profile?.playerId || null; }
  get isRegistered() { return this.profile?.accountType === 'google'; }

  save(session) {
    this.session = normalizeStored(session);
    if (this.session) this.storage?.setItem(STORAGE_KEY, JSON.stringify(this.session));
    else this.storage?.removeItem(STORAGE_KEY);
    return this.session;
  }

  async request(path, body) {
    const response = await this.fetchImpl(`${this.baseUrl}/api/identity/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    });
    let result = {};
    try { result = await response.json(); } catch {}
    if (!response.ok) {
      const error = new Error(result.error || 'Không thể xác thực người chơi');
      error.status = response.status;
      throw error;
    }
    return result;
  }

  async ensureGuest() {
    if (this.pendingGuest) return this.pendingGuest;
    this.pendingGuest = this.ensureGuestInternal();
    try {
      return await this.pendingGuest;
    } finally {
      this.pendingGuest = null;
    }
  }

  async ensureGuestInternal() {
    if (this.session?.token) {
      try {
        const result = await this.request('validate', { token: this.session.token });
        return this.save({
          token: this.session.token,
          expiresAt: result.expiresAt,
          profile: result.profile
        });
      } catch (error) {
        if (error.status !== 401 && error.status !== 404) throw error;
      }
    }

    const result = await this.request('guest', {});
    return this.save(result);
  }

  async updateProfile({ displayName, avatarId }) {
    if (!this.token) await this.ensureGuest();
    const result = await this.request('profile', {
      token: this.token,
      displayName,
      avatarId
    });
    return this.save({
      token: this.token,
      expiresAt: this.session?.expiresAt,
      profile: result.profile
    });
  }

  async signInWithGoogleCredential(credential) {
    const result = await this.request('google', {
      credential,
      guestToken: this.token || null
    });
    return this.save(result);
  }

  async logout() {
    const token = this.token;
    try {
      if (token) await this.request('logout', { token });
    } finally {
      this.clear();
    }
  }

  clear() {
    this.save(null);
  }
}

export function avatarFor(id) {
  return PLAYER_AVATARS.find(item => item.id === id) || PLAYER_AVATARS[0];
}
